import * as actions from './../actions/categoryMatching';
import config from "../config";

const CONFIG = config();


const initialState = {
	end_categories: [],
	matching_categories: [],
	catalog_names: CONFIG.CATALOG_NAMES || []
};

export default function category_matching(store = initialState, action) {
	switch (action.type) {
		case actions.TREES_LOADED:
			return Object.assign({}, store, {
				end_categories: action.end_categories,
				matching_categories: action.matching_categories
			});
		case actions.MATCHING_CATEGORY_DELETE:
		case actions.MATCHING_CATEGORY:
			store.matching_categories.map((category_matching, index) => {
				if(category_matching.id === action.category.id){
					store.matching_categories[index] = Object.assign({}, action.category);
				}

			});
			return Object.assign({}, store);

		default:
			return store;
	}
}



// WEBPACK FOOTER //
// ./frontend/reducers/category_matching.js